import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import {
  IIndirectTaxFilingV2GetParams,
  IIndirectTaxFilingV2GetResponse,
} from './types';

export function useIndirectTaxFilingV2(
  filingId: string | null | undefined,
  params: IIndirectTaxFilingV2GetParams | null
) {
  const query = new URLSearchParams();
  if (params) {
    query.append('corporationId', params.corporationId.toString());
    if (params.includeServiceRequest) {
      query.append('includeServiceRequest', 'true');
    }
    if (params.includeAssignedUser) {
      query.append('includeAssignedUser', 'true');
    }
    if (params.includeFiledByAgent) {
      query.append('includeFiledByAgent', 'true');
    }
  }

  const key =
    params && filingId
      ? `new-sales-tax/filings-v2/${filingId}?${query.toString()}`
      : null;

  const { data, error, isLoading, mutate } =
    useSWR<IIndirectTaxFilingV2GetResponse>(
      key,
      SWRFetcher({ method: 'GET' })
    );

  return {
    filing: data?.filing,
    isLoading,
    error,
    mutate,
  };
}
